import { KindOfResearch } from '../enums/kind-of-research.enum';

/** Cap with `features.increasedTargetLimit`; also the DTO hard cap. */
export const PARTICIPANT_ABSOLUTE_MAX = 500;
const DEFAULT_PARTICIPANT_LIMIT = 50;

/** Moderated, deprecated kinds and no kind fall back to the default. */
const LIMIT_BY_KIND: Record<number, number> = {
  [KindOfResearch.SURVEY]: 500,
  [KindOfResearch.AI_MODERATED_INTERVIEW]: 500,
  [KindOfResearch.UNMODERATED_STUDY]: 150,
  [KindOfResearch.DIARY_STUDY]: 150,
};

/**
 * Max recruitable participants for a draft/published project.
 * Survey and AI-moderated: 500; unmoderated and diary: 150; everything else
 * (moderated, deprecated kinds, no kind): 50. increasedTargetLimit → 500.
 */
export function getParticipantTargetLimit(
  kindOfResearch: number | null | undefined,
  increasedTargetLimit: boolean,
): number {
  if (increasedTargetLimit) {
    return PARTICIPANT_ABSOLUTE_MAX;
  }
  return (
    (kindOfResearch != null ? LIMIT_BY_KIND[kindOfResearch] : undefined) ??
    DEFAULT_PARTICIPANT_LIMIT
  );
}
